import { z } from 'zod';
import { ShopItem } from 'store/shop';
import { recognitionRewardsFiltersSchema } from './recognition-rewards.schemas';

export const recognitionRewardsVariants = [
  'all',
  'selected',
  'not-selected',
] as const;
export type RecognitionRewardsVariant =
  (typeof recognitionRewardsVariants)[number];

export type RecognitionRewardsConfig = Pick<
  RecognitionRewardsFilters,
  | 'suppliers'
  | 'categories'
  | 'cities'
  | 'countries'
  | 'taxExemptionStatus'
  | 'taxExemptionCountries'
>;

export interface RecognitionReward extends ShopItem {
  isWhitelisted: boolean;
  autoAssigned: boolean;
}

export type RecognitionRewardsFilters = z.infer<
  typeof recognitionRewardsFiltersSchema
>;
